import { useTheme } from 'styled-components';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { LanguageChooser } from '@savgroup-front-common/core/molecules/LanguageChooser';
import { ReversioIcon } from '@savgroup-front-common/core/protons/icons';
import { cn } from '@savgroup-front-common/primitive/lib/utils';

import {
  ACCEPTED_LANGUAGES,
  REVERSIO_WEBSITE_URL,
} from '../Onboarding.constants';

import messages from './messages';

export function PublicBar() {
  const theme = useTheme();

  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex h-16 items-center justify-between gap-4 px-4 md:px-7',
        'border-b sborder-base-default bg-surface-base-default',
      )}
    >
      <a
        href={REVERSIO_WEBSITE_URL}
        aria-label={safeFormattedIntlString(messages.homeLink)}
      >
        <ReversioIcon color={theme.newUI.defaultColors.menu} />
      </a>
      <LanguageChooser acceptedLanguages={ACCEPTED_LANGUAGES} />
    </header>
  );
}
